import { all, fork } from 'redux-saga/effects';

import accessibilityReducer from './accessibility/reducer';

import avatarReducer from './avatar/reducer';
import avatarSaga from './avatar/saga';

import feedbackReducer from './feedback/reducer';
import feedbackSaga from './feedback/saga';

import incomingDataReducer from './incomingData/reducer';

import lkIpReducer from './lkIp/reducer';
import lkIpSaga from './lkIp/saga';

import propertyObjectsReducer from './propertyObjects/reducer';
import propertyObjectsSaga from './propertyObjects/saga';

import propertyObjectTypesReducer from './propertyObjectTypes/reducer';
import propertyObjectTypesSaga from './propertyObjectTypes/saga';

import routerSaga from './router/saga';
import updateLoadedDataSaga from './updateLoadedData/saga';

import saveEmailReducer from './saveEmail/reducer';
import saveEmailSaga from './saveEmail/saga';

import searchInnReducer from './searchInn/reducer';
import searchInnSaga from './searchInn/saga';

import userReducer from './user/reducer';
import userSaga from './user/saga';

import checkFacetStatusReducer from './checkFacetStatus/reducer';
import checkFacetStatusSaga from './checkFacetStatus/saga';

import oldVersionTokenReducer from './oldVersionToken/reducer';
import oldVersionTokenSaga from './oldVersionToken/saga';

import bannerListReducer, { showTourReducer } from './bannerList/reducer';
import bannerListSaga from './bannerList/saga';
import searchModalReducer from './serachOverlay/reducer';
import calendarEventsReducer from './calendarEvents/reducer';
import calendarEventsSaga from './calendarEvents/saga';

import siteMapReducer from './siteMap/reducer';
import siteMapSaga from './siteMap/saga';

import adminCofigReducer from './adminConfig/reducer';
import adminConfigSaga from './adminConfig/saga';
import catchErrorReducer from './catchErrorRequest/reducer';
import appReducer from './app/appReducer';

export const appReducers = {
  app: appReducer,
  user: userReducer,
  propertyObjects: propertyObjectsReducer,
  propertyObjectTypes: propertyObjectTypesReducer,
  feedback: feedbackReducer,
  incomingData: incomingDataReducer,
  saveEmail: saveEmailReducer,
  innSearching: searchInnReducer,
  avatar: avatarReducer,
  accessibility: accessibilityReducer,
  lkIp: lkIpReducer,
  checkFacetStatus: checkFacetStatusReducer,
  oldToken: oldVersionTokenReducer,
  bannerList: bannerListReducer,
  showTour: showTourReducer,
  calendarEvents: calendarEventsReducer,
  searchModal: searchModalReducer,
  siteMap: siteMapReducer,
  adminConfig: adminCofigReducer,
  catchErrors: catchErrorReducer,
};

export function* appSagas() {
  yield all(
    [
      routerSaga,
      userSaga,
      propertyObjectsSaga,
      propertyObjectTypesSaga,
      feedbackSaga.getSubjectsSaga,
      feedbackSaga.saveFeedbackSaga,
      saveEmailSaga,
      searchInnSaga,
      avatarSaga,
      lkIpSaga,
      checkFacetStatusSaga,
      updateLoadedDataSaga,
      oldVersionTokenSaga,
      bannerListSaga,
      siteMapSaga,
      calendarEventsSaga,
      adminConfigSaga,
    ].map(function (saga) {
      return fork(saga);
    }),
  );
}
